module.exports = __webpack_public_path__ + "img/c23.f088bc6b.png";